export default __webpack_public_path__ + "static/media/4-2_image01@2x.e4e4d229.png";